import Fuse from 'fuse.js';
// import autocomplete from "autocompleter";
// import AutoComplete from "@tarekraafat/autocomplete.js";

document.addEventListener('DOMContentLoaded', function () {
  const toggleElements = document.querySelectorAll('[data-search-toggle]');
  const main = document.querySelector('#main');
  const toggleClass = 'is-search-open';

  function toggleSearchMode() {
    main.classList.toggle(toggleClass);
    if (main.classList.contains(toggleClass)) {
      const input = document.querySelector(
        '[data-search-input][data-id="bar"]'
      );
      if (input) {
        input.focus();
        if (input.value) {
          input.select();
        }
      }
      main.classList.remove('is-menu-open');
    }
  }

  toggleElements.forEach(function (el) {
    el.addEventListener('click', function () {
      toggleSearchMode();
    });
  });

  const inputs = document.querySelectorAll(
    '[data-search-input][data-id="search-hero"]'
  );
  // const datalist = document.getElementById('suggestions');
  const terms = window.autocompleteTerms;

  const suggestionsList = document.querySelector('[data-input-autocomplete]');
  let currentIndex = -1;

  inputs.forEach(function (input) {
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      if (query.length < 2) {
        clearSuggestions();
        return;
      }

      const fuseOptions = {
        threshold: 0.3,
      };

      const fuse = new Fuse(terms, fuseOptions);

      const results = query
        ? fuse.search(query).map((result) => result.item)
        : [];
      renderSuggestions(results);
    });

    input.addEventListener('keydown', (e) => {
      const items = suggestionsList.querySelectorAll('li');
      if (e.key === 'ArrowDown') {
        currentIndex = (currentIndex + 1) % items.length;
        highlight(items);
        e.preventDefault();
      } else if (e.key === 'ArrowUp') {
        currentIndex = (currentIndex - 1 + items.length) % items.length;
        highlight(items);
        e.preventDefault();
      } else if (e.key === 'Enter' && currentIndex >= 0) {
        input.value = items[currentIndex].textContent;
        clearSuggestions();
        e.preventDefault();
      }

      if (e.key === 'Enter') {
        launchSearch();
        e.preventDefault();
      }
    });

    suggestionsList.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if (li) {
        input.value = li.textContent;
        launchSearch();
        clearSuggestions();
      }
    });

    function launchSearch() {
      const barInput = document.querySelector(
        '[data-search-input][data-id="bar"]'
      );
      if (barInput) {
        barInput.value = input.value;
        const event = new KeyboardEvent('keydown', { bubbles: true });
        barInput.dispatchEvent(event);
      }
      toggleSearchMode();
    }

    const icon = input.parentElement.querySelector('.input__icon');
    if (icon) {
      icon.addEventListener('click', () => {
        launchSearch(input.value);
        showSuggestions();
      });
    }

    input.addEventListener('focus', () => {
      // console.log('focus', input, suggestionsList);
      showSuggestions();
    });

    input.addEventListener('click', () => {
      // console.log('focusclick', input, suggestionsList);
      showSuggestions();
    });

    function renderSuggestions(matches) {
      // console.log('renderSuggestions', matches);
      suggestionsList.innerHTML = '';
      currentIndex = -1;
      const query = input.value.trim().toLowerCase();
      const limitedMatches = matches.slice(0, 4);
      limitedMatches.forEach((match) => {
        const li = document.createElement('li');
        // Highlight the search term within the suggestion
        const regex = new RegExp(
          `(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
          'ig'
        );
        li.innerHTML = match.replace(regex, '<mark>$1</mark>');
        li.addEventListener('click', () => {
          input.value = match;
          clearSuggestions();
        });
        suggestionsList.appendChild(li);
      });
      if (limitedMatches.length === 0) hideSuggestions();
      else showSuggestions();
    }

    function highlight(items) {
      items.forEach((item, index) => {
        item.setAttribute(
          'aria-selected',
          index === currentIndex ? 'true' : 'false'
        );
      });
    }

    function clearSuggestions() {
      // console.log('clearSuggestions');
      suggestionsList.innerHTML = '';
      currentIndex = -1;
      hideSuggestions();
    }

    function showSuggestions() {
      // console.log('showSuggestions');
      if (suggestionsList) {
        suggestionsList.style.display = 'block';
      }
    }

    function hideSuggestions() {
      // console.log('hideSuggestions');
      if (suggestionsList) {
        suggestionsList.style.display = 'none';
      }
    }
  });

  // Attach document click listener only once, outside the input loop
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-search-input-wrapper]')) {
      if (suggestionsList) {
        suggestionsList.style.display = 'none';
      }
    }
  });
});
